import gql from 'graphql-tag';

export default gql`
  mutation orderUpdatePurchaserName($input: OrderUpdatePurchaserNameInput!) {
    orderUpdatePurchaserName(input: $input) {
      success
      order {
        purchaserName
      }
    }
  }
`;
